<template>
  <div>
    <v-tabs fixed-tabs color="primary" dark slider-color="cyan lighten-5">
      <v-tab :key="0"> Laboratories </v-tab>
      <v-tab :key="1"> Reactions </v-tab>
      <v-tab :key="2"> Stains </v-tab>
      <v-tab :key="3"> Slide Service </v-tab>
      <v-tab :key="4"> Cost Centers </v-tab>
      <v-tab-item :key="0">
        <laboratories></laboratories>
      </v-tab-item>
      <v-tab-item :key="1">
        <reactions></reactions>
      </v-tab-item>
      <v-tab-item :key="2">
        <stains></stains>
      </v-tab-item>
      <v-tab-item :key="3">
        <slide-service></slide-service>
      </v-tab-item>
      <v-tab-item :key="4">
        <cost-centers></cost-centers>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Laboratories from "./Laboratories";
import Reactions from "./Reactions";
import Stains from "./Stains";
import SlideService from "./SlideService";
import CostCenters from "./CostCenters";

export default {
  name: "References",
  components: {
    Laboratories,
    Reactions,
    Stains,
    SlideService,
    CostCenters
  },
  mounted() {
    this.getInitialData();
  },
  methods: {
    ...mapActions({
      getInitialData: "commonGetInitialData"
    })
  }
};
</script>



// WEBPACK FOOTER //
// src/components/References/Index.vue